<template>
  <body>
    <div class="menu-container">
      <div class="menu-sections">
        <div class="menu-section" v-for="(section, index) in menusections" :key="index">
          <h2 class="section-heading">{{ section.heading }}</h2>
          <ul class="menu-items">
            <li class="menu-item" v-for="(item, itemIndex) in section.items" :key="itemIndex">
              <div class="item-name">
                <span>{{ item.name }}</span>
                <span class="item-price">{{ item.price }}</span>
              </div>
              <p v-if="item.desc" class="item-desc">{{ item.desc }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </body>
  
  </template>

<script>
    export default {
        data() {
            return {
                menusections: [
                    {
                    heading: 'Läsk/alkoholfritt',
                    items: [
                    {name: 'Pepsi (30cl)', price: '39:-'},
                    {name: 'Pepsi Max (30cl)', price: '39:-'},
                    {name: 'Zingo (30cl)', price: '39:-'},
                    {name: '7up (30cl)', price: '39:-'},
                    {name: 'Mineralvatten', price: '39:-'},
                    {name: 'Bryggkaffe', price: '39:-'},
                    {name: 'Alkoholfri öl (33cl)', price: '59:-'},
                    {name: 'Alkoholfri Päroncider (33cl)', price: '59:-'},
                    {name: 'Ett glas alkoholfritt vin', desc: 'Rött eller vitt', price: '79:-'},
                    {name: 'Alkoholfri Drink', price: '79:-'},

                    ]
                    },
                    {
                    heading: 'Fatöl',
                    items: [
                    {name: 'Grängesberg', desc: '', price: '49:-'},
                    {name: 'Norrlands Guld', desc: '', price: '59:-'},
                    {name: 'A Ship full of Ipa', price: '88:-'},
                    {name: 'Krusovice Imperial', desc: '', price: '88:-'},
                    ]
                    },
                    {
                    heading: 'Flasköl', 
                    items: [
                    {name: 'Mariestad (33cl)', desc: 'Mellanöl', price: '69:-'},
                    {name: 'Sol (33cl)', desc: '', price: '69:-'},
                    {name: 'Heineken (33cl)', desc: '', price: '69:-'},
                    {name: 'Sleepy bulldog (33cl)', desc: '', price: '69:-'},
                    {name: 'Daura damm (33cl)', desc: 'Glutenfri', price: '69:-'},
                    {name: 'Mariestad (50cl)', desc: 'Export', price: '84:-'},
                    {name: 'Veteöl (50cl)', desc: '', price: '94:-'}            
                    ]
                    },
                    {
                    heading: 'Cider/breezer',
                    items: [
                    {name: 'Briska', desc: 'Päron/fläder/hallon', price: '79:-'},
                    {name: 'Strongbow', desc: '', price: '79:-'},
                    {name: 'Smirnoff ice', desc: '', price: '79:-'},
                    {name: 'Breezer', desc: 'Mango', price: '79:-'}
                    ]
                    }, 
                    {
                    heading: 'Rött/vitt/rosé vin',
                    items: [
                    {name: 'Husets glas', desc: '', price: '84:-'},
                    {name: 'Husets flaska', desc: '', price: '369:-'},
                    {name: 'Husets flaska (AW)', desc: '', price: '329:-'}
                    ]
                    },
                    {
                    heading: 'Mouserrande',
                    items: [
                    {name: 'Ett glas cava', desc: '', price: '99:-'},
                    {name: 'En flaska cava', desc: '', price: '409:-'},
                    ]
                    },
                    {
                    heading: 'drinkar/cocktails (5cl)',
                    items: [
                    {name: 'Olika drinkar/cocktails', price: 'fr. 139:-'},

                    ]
                    },
                    {
                    heading: 'shots (5cl)',
                    items: [
                    {name: 'Olika shots', price: 'fr. 109:-'}
                    ]
                    },
                    {
                    heading: 'Whiskey/cognac',
                    items: [
                    {name: 'Olika whiskeys', price: 'fr. 28:-/cl'}
                    ]
                    },
                ]
            }
        }
    }
</script>

<style scoped>
body {
  background-color: #000; 
  color: #fff;
  margin: 0;
  padding: 0;
}

.menu-container {
  padding: 50px 20px;
}

.menu-title {
  font-size: 3.5rem;
  color: #ff8800;
  margin-bottom: 40px;
  text-transform: uppercase;
}

.menu-sections {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
}

.menu-section {
  width: 90%;
  max-width: 800px;
  background-color: #1e1e1e; /* Mörkare grön för sektionerna */
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.section-heading {
  font-size: 2.5rem;
  color: #937d51;
  border-bottom: 3px solid #937d51;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.menu-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.menu-item:last-child {
  border-bottom: none;
}

.item-name {
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.item-price {
  font-weight: bold;
  color: #937d51; /* Guld-färg för priser */
}

.item-desc {
  margin-top: 5px;
  font-size: 1.2rem;
  color: #dcdcdc;
}

</style>